import React, { Component } from 'react';

class Header extends Component {

    render() { 
        return (  
            <header id="header-main">
                <nav className="navbar nav-ian primary-back-color">
                    <a href="/" className="navbar-brand mx-auto mt-5"><img src={process.env.PUBLIC_URL + '/images/GPA-Logo.png'} alt="gpa-logo"></img></a>
                </nav>
            </header>
        );
    }
}
 
export default Header;